module.exports = __webpack_public_path__ + "static/img/caoxi.d3a188c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/touxiang/caoxi.png
// module id = sXU2
// module chunks = 0